import { useState, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from './use-toast';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useAdminSettings = () => {
  const { token } = useAuth();
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);

  const apiCall = useCallback(async (method, endpoint, data = null) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };
      
      let response;
      if (method === 'get') {
        response = await axios.get(`${API_URL}${endpoint}`, config);
      } else if (method === 'post') {
        response = await axios.post(`${API_URL}${endpoint}`, data, config);
      } else if (method === 'put') {
        response = await axios.put(`${API_URL}${endpoint}`, data, config);
      } else if (method === 'delete') {
        response = await axios.delete(`${API_URL}${endpoint}`, config);
      }
      
      return response.data;
    } catch (error) {
      console.error(`API Error (${method} ${endpoint}):`, error);
      throw error;
    }
  }, [token]);

  const showSuccess = useCallback((message) => {
    toast({ title: 'Success', description: message });
  }, [toast]);

  const showError = useCallback((message) => {
    toast({ variant: 'destructive', title: 'Error', description: message });
  }, [toast]);

  return {
    token,
    loading,
    setLoading,
    apiCall,
    showSuccess,
    showError
  };
};

export default useAdminSettings;
